function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FloatingPortal, flip, offset, shift, useClick, useFloating, useInteractions } from '@floating-ui/react';
import { debounce } from 'lodash';
import React, { forwardRef, useContext, useEffect, useMemo, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useClickOutside } from '../../../hooks/useClickOutside';
import useEventListener from '../../../hooks/useEventListener';
import CollapseButton from '../../button/CollapseButton';
import { MapViewContext } from '../../mapView/mapViewContext';
import Body from './components/Body';
import Footer from './components/Footer';
import Header from './components/Header';
// Temporarily hide these buttons until the underlying features are implemented
var HIDE_PREVIEW = true;
var HIDE_SCREENSHOT = true;
var SHOW_HEADER = !HIDE_PREVIEW || !HIDE_SCREENSHOT;
var ProductModal = /*#__PURE__*/ forwardRef(function(_, ref) {
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var productModalPopupRef = useRef(null);
    var _state_productSelected = state.productSelected, productType = _state_productSelected.product;
    var isProductSelectedFocused = useMemo(function() {
        var _state_activeSelection;
        return ((_state_activeSelection = state.activeSelection) === null || _state_activeSelection === void 0 ? void 0 : _state_activeSelection.category_name) === productType;
    }, [
        state.activeSelection,
        productType
    ]);
    useClickOutside(productModalPopupRef, function() {
        actions.clearProductSelected();
        actions.closeShapeMenuModal();
    }, [
        '#product-dropdown-menu-container .modal-content',
        '.product-row-container',
        '.layers-panel-container .layer'
    ], isProductSelectedFocused);
    var _useFloating = useFloating({
        placement: 'left',
        middleware: [
            flip(),
            offset(32),
            shift({
                padding: 16
            })
        ]
    }), xPos = _useFloating.x, refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, context = _useFloating.context, update = _useFloating.update;
    var click = useClick(context);
    var getFloatingProps = useInteractions([
        click
    ]).getFloatingProps;
    useEffect(function() {
        if (ref.current) {
            refs.setReference(ref.current);
            update();
        }
    }, [
        update,
        refs,
        xPos,
        state.showProductModal,
        state.isProductModalExpanded,
        state.productSelected,
        state.selections,
        ref
    ]);
    var handleEscapePress = function(event) {
        if (event.key === 'Escape') {
            actions.closeShapeMenuModal();
            actions.clearProductSelected();
        }
    };
    useEventListener('keydown', handleEscapePress, document);
    useEventListener('resize', update);
    useEventListener('wheel', debounce(update, 500));
    return /*#__PURE__*/ React.createElement(FloatingPortal, null, /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: refs.setFloating,
        style: _object_spread_props(_object_spread({}, floatingStyles), {
            zIndex: 1000
        })
    }, getFloatingProps()), /*#__PURE__*/ React.createElement(Modal.Dialog, {
        id: "product-modal",
        ref: productModalPopupRef
    }, SHOW_HEADER ? /*#__PURE__*/ React.createElement(Header, {
        isPreviewButtonHidden: HIDE_PREVIEW,
        isScreenshotButtonHidden: HIDE_SCREENSHOT
    }) : null, /*#__PURE__*/ React.createElement(Body, {
        isHeaderShown: SHOW_HEADER
    }), /*#__PURE__*/ React.createElement(Footer, null), /*#__PURE__*/ React.createElement(CollapseButton, {
        id: "productInfoCollapseButton",
        openDirection: "down",
        isOpen: state.isProductModalExpanded,
        closeText: "More info",
        className: "flex-row-reverse ",
        onClick: function() {
            return actions.setIsProductModalExpanded(!state.isProductModalExpanded);
        }
    }))));
});
ProductModal.displayName = 'ProductModal';
export default ProductModal;
